import { useMemo } from 'react';

export const useColumns = () => {
  return useMemo(() => {
    return [
      {
        field: 'employeeNumber',
        headerName: 'No.',
        width: 80,
        align: 'left',
        headerAlign: 'left',
      },
      {
        field: 'rank',
        headerName: 'Rank',
        width: 80,
        align: 'left',
        headerAlign: 'left',
      },
      {
        field: 'fullName',
        headerName: 'Name',
        width: 180,
        align: 'left',
        headerAlign: 'left',
      },
      {
        field: 'regularHours',
        headerName: 'hrs',
        width: 60,
        type: 'number',
        align: 'left',
        headerAlign: 'left',
      },
      {
        field: 'sickHours',
        headerName: 'Sick',
        width: 50,
        align: 'left',
        headerAlign: 'left',
      },
      {
        field: 'vacationHours',
        headerName: 'Vac.',
        width: 50,
        align: 'left',
        headerAlign: 'left',
      },
      {
        field: 'totalHours',
        headerName: 'hrs',
        width: 60,
        type: 'number',
        align: 'left',
        headerAlign: 'left',
      },
      {
        field: 'hourlyRate',
        headerName: 'hrly',
        width: 80,
        type: 'number',
        align: 'left',
        headerAlign: 'left',
      },
      {
        field: 'weeklyPay',
        headerName: 'wkly pay',
        width: 80,
        type: 'number',
        align: 'left',
        headerAlign: 'left',
      },
      {
        field: 'additionalHours',
        headerName: 'hrs',
        width: 50,
        type: 'number',
        align: 'left',
        headerAlign: 'left',
      },
      {
        field: 'rate2',
        headerName: 'Rate 2',
        width: 80,
        align: 'left',
        headerAlign: 'left',
      },
      {
        field: 'rate23',
        headerName: '23',
        width: 50,
        align: 'left',
        headerAlign: 'left',
      },
      {
        field: 'amount1',
        headerName: 'Amt',
        width: 80,
        type: 'number',
        align: 'left',
        headerAlign: 'left',
      },
      {
        field: 'rate34_50',
        headerName: '34.50',
        width: 80,
        align: 'left',
        headerAlign: 'left',
      },
      {
        field: 'amount2',
        headerName: 'Amt',
        width: 80,
        type: 'number',
        align: 'left',
        headerAlign: 'left',
      },
      {
        field: 'hourlyRate2',
        headerName: 'Hrly',
        width: 80,
        align: 'left',
        headerAlign: 'left',
      },
      {
        field: 'overtimeHours1',
        headerName: 'hrs',
        width: 50,
        type: 'number',
        align: 'left',
        headerAlign: 'left',
      },
      {
        field: 'overtimeRate1',
        headerName: 'OT 1',
        width: 80,
        align: 'left',
        headerAlign: 'left',
      },
      {
        field: 'overtimeHours2',
        headerName: 'hrs',
        width: 50,
        type: 'number',
        align: 'left',
        headerAlign: 'left',
      },
      {
        field: 'overtimeRate2',
        headerName: 'OT 2',
        width: 80,
        align: 'left',
        headerAlign: 'left',
      },
      {
        field: 'overtimeHours3',
        headerName: 'hrs',
        width: 50,
        type: 'number',
        align: 'left',
        headerAlign: 'left',
      },
      {
        field: 'overtimeRate3',
        headerName: 'OT 3',
        width: 80,
        align: 'left',
        headerAlign: 'left',
      },
      {
        field: 'hours10',
        headerName: '10 hrs',
        width: 80,
        align: 'left',
        headerAlign: 'left',
      },
      {
        field: 'amount3',
        headerName: 'Amt',
        width: 80,
        type: 'number',
        align: 'left',
        headerAlign: 'left',
      },
      {
        field: 'detail',
        headerName: 'Detail',
        width: 80,
        align: 'left',
        headerAlign: 'left',
      },
      {
        field: 'totalPay',
        headerName: 'Pay',
        width: 90,
        type: 'number',
        align: 'left',
        headerAlign: 'left',
      },
    ];
  }, []);
};

export default useColumns;
